// pages/ICoverLoginPage.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../src/Context/AuthContext';
import EmptyHeader from '../../Components/Shared/EmptyHeader';
import AuthHeader from '../../Components/Account/AuthHeader';

const ICoverLoginPage = ({ portalSettings }) => {
    const { login } = useAuth();
    const [searchParams] = useSearchParams();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const companyName = import.meta.env.VITE_COMPANY_NAME;
    const apiURL = import.meta.env.VITE_API;

    const redirectUri = useMemo(() => {
        return searchParams.get('redirect_uri') || searchParams.get('redirect');
    }, [searchParams]);

    useEffect(() => {
        document.title = `${companyName} - iCover Login`;
    }, [companyName]);

    if (!portalSettings) return null;

    const handleLogin = async (e) => {
        e.preventDefault();

        if (!redirectUri) {
            alert('Missing iCover redirect URL.');
            return;
        }

        const res = await fetch(`${apiURL}/account/ICoverLogin`, {
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                userName: username,
                password,
                redirectUri,
            }),
        });

        if (!res.ok) {
            const errorData = await res.json().catch(() => ({}));
            alert(errorData.message || 'Login failed.');
            return;
        }

        const data = await res.json();
        const result = data.result;

        switch (result?.resultType) {
            case 0:
                login();

                if (result.redirectLink) {
                    window.location.assign(result.redirectLink);
                    return;
                }

                alert('Missing iCover redirect response.');
                break;

            case 17:
                navigate(
                    `/icover-twofactor?token=${encodeURIComponent(result.token)}&redirect_uri=${encodeURIComponent(redirectUri)}`
                );
                break;

            default:
                alert('Unexpected response from server.');
                break;
        }
    };

    return (
        <div className="auth-page">
            <EmptyHeader />
            <EmptyHeader />
            <EmptyHeader />
            <div className="auth-container">
                <AuthHeader portalSettings={portalSettings} />
                <h2 className="baseHeader">iCover Login</h2>

                <form className="baseForm" onSubmit={handleLogin}>
                    <label className="baseLabel">Username</label>
                    <input
                        className="baseInput"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />

                    <label className="baseLabel">Password</label>
                    <input
                        className="baseInput"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />

                    <button className="baseButton" type="submit">Login</button>
                </form>

                <div className="auth-links">
                    <Link to="/forgotusername">Forgot Username?</Link>
                    <Link to="/forgotpassword">Forgot Password?</Link>
                </div>
            </div>
        </div>
    );
};

export default ICoverLoginPage;